// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_2z0-I","visuallyhidden":"_2Rk2P","hide-text":"Cf0hO","center":"_3H-ph","noprint":"_3AhlR","subtitle":"_27fbY"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-subtitle/styles/Subtitle_Factbox.scss
 ** module id = 954
 ** module chunks = 1
 **/